(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var menuBtn = document.querySelector("[data-menu]");
  var nav = document.querySelector("[data-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  function inView(el, onEnter, onLeave) {
    if (!("IntersectionObserver" in window)) {
      onEnter();
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) onEnter();
        else if (onLeave) onLeave();
      });
    }, { threshold: 0.35 });
    obs.observe(el);
  }

  var stages = [];
  var stageObs = null;
  function stage(el, play, stop) {
    if (!el) return;
    var slot = { el: el, play: play, stop: stop, ratio: 0, on: false };
    stages.push(slot);
    if (!("IntersectionObserver" in window)) {
      play();
      return;
    }
    if (!stageObs) {
      stageObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stages.forEach(function (item) {
            if (item.el === entry.target) item.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          });
        });
        var best = null;
        stages.forEach(function (item) {
          if (item.ratio >= 0.5 && (!best || item.ratio > best.ratio)) best = item;
        });
        stages.forEach(function (item) {
          var active = item === best;
          if (active && !item.on) {
            item.on = true;
            item.play();
          } else if (!active && item.on) {
            item.on = false;
            item.stop();
          }
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    }
    stageObs.observe(el);
  }

  stage(document.querySelector("[data-expand]"), function () {}, function () {});

  var hero = document.querySelector("[data-hero]");
  if (hero) {
    var slides = [].slice.call(hero.querySelectorAll(".hero-slide"));
    var dots = [].slice.call(hero.querySelectorAll("[data-dot]"));
    var pauseBtn = hero.querySelector("[data-pause]");
    var index = 0;
    var timer = 0;
    var paused = reduce;
    var wipeToken = 0;

    function markDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-on", i === index);
        dot.setAttribute("aria-pressed", i === index ? "true" : "false");
      });
    }

    function settle(token) {
      if (token !== wipeToken) return;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle("is-on", on);
        slide.classList.remove("is-wipe", "is-leave");
        slide.setAttribute("aria-hidden", on ? "false" : "true");
      });
    }

    function show(next, animate) {
      var prev = index;
      index = (next + slides.length) % slides.length;
      markDots();
      if (!animate || reduce || prev === index) {
        wipeToken += 1;
        settle(wipeToken);
        return;
      }
      var token = ++wipeToken;
      var incoming = slides[index];
      slides.forEach(function (slide, i) {
        if (i !== prev && i !== index) {
          slide.classList.remove("is-on", "is-wipe", "is-leave");
          slide.setAttribute("aria-hidden", "true");
        }
      });
      slides[prev].classList.add("is-on", "is-leave");
      incoming.classList.add("is-on");
      incoming.setAttribute("aria-hidden", "false");
      incoming.classList.remove("is-wipe");
      void incoming.offsetWidth;
      incoming.classList.add("is-wipe");
      function finish(event) {
        if (event && (event.target !== incoming || event.animationName !== "hero-reveal")) return;
        settle(token);
      }
      incoming.addEventListener("animationend", finish, { once: true });
      window.setTimeout(function () { settle(token); }, 1100);
    }

    function stop() { window.clearInterval(timer); timer = 0; }
    function play() {
      stop();
      if (paused || reduce || slides.length < 2) return;
      timer = window.setInterval(function () { show(index + 1, true); }, 5200);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { show(i, true); play(); });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener("click", function () {
        paused = !paused;
        pauseBtn.textContent = paused ? "Play" : "Pause";
        pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
        if (paused) stop();
        else play();
      });
      if (reduce) {
        pauseBtn.hidden = true;
      }
    }
    stage(hero, play, stop);
    show(0);
  }

  var compare = document.querySelector("[data-compare]");
  if (compare) {
    var range = compare.querySelector("input");
    var frame = compare.querySelector(".compare-stage");
    var dining = compare.querySelector(".compare-a");
    var gaming = compare.querySelector(".compare-b");
    var ratio = 0.5;
    var dragging = false;
    var hinted = false;

    function apply(next) {
      ratio = Math.min(1, Math.max(0, next));
      var pct = ratio * 100;
      frame.style.setProperty("--progress", String(ratio));
      dining.style.visibility = "";
      gaming.style.visibility = "";
      gaming.style.clipPath = "";
      range.value = String(pct);
      range.setAttribute("aria-valuenow", String(Math.round(pct)));
      range.setAttribute("aria-valuetext", Math.round(pct) + " percent gaming");
    }

    function ratioFromPoint(clientX) {
      var rect = frame.getBoundingClientRect();
      var width = rect.width || 1;
      return 1 - Math.min(1, Math.max(0, (clientX - rect.left) / width));
    }

    apply(0.5);

    range.addEventListener("pointerdown", function (event) {
      dragging = true;
      hinted = true;
      if (range.setPointerCapture) range.setPointerCapture(event.pointerId);
      apply(ratioFromPoint(event.clientX));
    });
    range.addEventListener("pointermove", function (event) {
      if (!dragging) return;
      apply(ratioFromPoint(event.clientX));
    });
    function release() { dragging = false; }
    range.addEventListener("pointerup", release);
    range.addEventListener("pointercancel", release);
    range.addEventListener("input", function () {
      if (dragging) return;
      apply(Number(range.value) / 100);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { apply(ratio); }).observe(frame);
    } else {
      window.addEventListener("resize", function () { apply(ratio); });
    }

    function hint() {
      if (hinted || reduce || dragging) return;
      hinted = true;
      var start = 0;
      function step(now) {
        if (!start) start = now;
        if (dragging) return;
        var t = (now - start) / 900;
        if (t < 0.5) apply(0.5 + 0.16 * (t / 0.5));
        else if (t < 1) apply(0.66 - 0.16 * ((t - 0.5) / 0.5));
        else { apply(0.5); return; }
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
    inView(compare, hint);
  }

  function stepper(root, meterStops) {
    if (!root) return;
    var frames = [].slice.call(root.querySelectorAll(".stage-frame img"));
    var buttons = [].slice.call(root.querySelectorAll(".steps button:not([data-step-pause])"));
    var meter = root.querySelector(".meter span");
    var index = 0;
    var timer = 0;
    var paused = false;
    var holds = [5600, 5600, 6200, 7000];

    function show(next) {
      index = (next + frames.length) % frames.length;
      frames.forEach(function (frame, i) {
        var on = i === index;
        frame.classList.toggle("is-on", on);
        frame.setAttribute("aria-hidden", on ? "false" : "true");
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle("is-on", i === index);
        button.setAttribute("aria-pressed", i === index ? "true" : "false");
      });
      if (meter) meter.style.setProperty("--meter", meterStops[index] || "100%");
      var span = frames.length < 2 ? 0 : index / (frames.length - 1);
      root.style.setProperty("--kit", String(span));
      placeFill();
      var note = root.querySelector("[data-tower-note]");
      var active = frames[index];
      if (note && active && active.getAttribute("data-note")) note.textContent = active.getAttribute("data-note");
    }

    function placeFill() {
      var line = root.querySelector(".kit-line");
      var fill = line && line.firstElementChild;
      var spine = root.querySelector(".kit-spine");
      if (!line || !fill || !spine || !buttons.length) return;
      var spineRect = spine.getBoundingClientRect();
      var first = buttons[0].getBoundingClientRect();
      var last = buttons[buttons.length - 1].getBoundingClientRect();
      var start = first.top + first.height / 2 - spineRect.top;
      var end = last.top + last.height / 2 - spineRect.top;
      line.style.top = start + "px";
      line.style.bottom = "auto";
      line.style.height = Math.max(0, end - start) + "px";
      var btn = buttons[index].getBoundingClientRect();
      var center = btn.top + btn.height / 2 - line.getBoundingClientRect().top;
      var h = line.getBoundingClientRect().height;
      var pct = h ? Math.max(0, Math.min(100, (center / h) * 100)) : 0;
      fill.style.height = pct + "%";
    }

    function stop() { window.clearTimeout(timer); timer = 0; }
    function play() {
      stop();
      if (reduce || paused) return;
      timer = window.setTimeout(function () {
        show(index + 1);
        play();
      }, holds[index] || 5200);
    }

    buttons.forEach(function (button, i) {
      button.addEventListener("click", function () {
        paused = true;
        show(i);
        stop();
        if (stepPause) {
          stepPause.textContent = "Play";
          stepPause.setAttribute("aria-pressed", "true");
        }
      });
    });
    var stepPause = root.querySelector("[data-step-pause]");
    if (stepPause) {
      stepPause.addEventListener("click", function () {
        paused = !paused;
        stepPause.textContent = paused ? "Play" : "Pause";
        stepPause.setAttribute("aria-pressed", paused ? "true" : "false");
        if (paused) stop();
        else play();
      });
      if (reduce) stepPause.hidden = true;
    }
    stage(root, play, stop);
    show(reduce ? frames.length - 1 : 0);
    window.addEventListener("resize", placeFill);
  }

  stepper(document.querySelector("[data-tower]"), ["25%", "50%", "75%", "100%"]);

  var expand = document.querySelector("[data-expand]");
  if (expand) {
    var frames = [].slice.call(expand.querySelectorAll("[data-frame]"));
    var labels = [].slice.call(expand.querySelectorAll("[data-label]"));
    var meter = expand.querySelector(".meter span");
    var reduceExpand = reduce;

    function paintExpand(progress) {
      var p = Math.min(1, Math.max(0, progress));
      if (meter) meter.style.setProperty("--meter", (22 + p * 78) + "%");
      function ramp(value, a, b) {
        if (value <= a) return 0;
        if (value >= b) return 1;
        return (value - a) / (b - a);
      }
      var spans = [0, 0.28, 0.62, 1];
      var shown = frames.map(function (frame, i) {
        var fadeIn = i === 0 ? 1 : ramp(p, spans[i] + 0.02, spans[i] + 0.055);
        var leave = i === frames.length - 1 ? 0 : ramp(p, spans[i + 1], spans[i + 1] + 0.02);
        return fadeIn * (1 - leave);
      });
      var active = 0;
      shown.forEach(function (value, i) {
        if (value > shown[active]) active = i;
      });
      frames.forEach(function (frame, i) {
        var open = i === 0 ? ramp(p, 0, 0.22) : ramp(p, spans[i] + 0.02, spans[i] + 0.16);
        var scale = 1.045 - 0.045 * open;
        frame.style.opacity = String(shown[i]);
        frame.style.visibility = shown[i] <= 0.004 ? "hidden" : "visible";
        frame.style.zIndex = String(i + 1);
        frame.style.transform = "scale(" + scale.toFixed(4) + ")";
        frame.style.clipPath = "none";
        frame.setAttribute("aria-hidden", i === active ? "false" : "true");
        frame.classList.toggle("is-on", i === active);
      });
      labels.forEach(function (label, i) {
        label.classList.toggle("is-on", i === active);
      });
    }

    function onScroll() {
      var rect = expand.getBoundingClientRect();
      var total = expand.offsetHeight - window.innerHeight;
      var traveled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      paintExpand(total > 0 ? traveled / total : 0);
    }

    if (reduceExpand || (window.Shopify && window.Shopify.designMode)) {
      paintExpand(1);
    } else {
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
    }
  }

  function reel(root) {
    var frames = [].slice.call(root.querySelectorAll("[data-reel-frame]"));
    var labels = [].slice.call(root.querySelectorAll("[data-reel-label]"));
    var meter = root.querySelector("[data-reel-meter]");
    var pause = root.querySelector("[data-reel-pause]");
    if (!frames.length) return;
    var index = 0;
    var timer = 0;
    var paused = false;
    var hold = Number(root.getAttribute("data-hold")) || 5200;

    function show(i) {
      index = (i + frames.length) % frames.length;
      frames.forEach(function (frame, n) {
        var on = n === index;
        frame.classList.toggle("is-on", on);
        frame.setAttribute("aria-hidden", on ? "false" : "true");
      });
      labels.forEach(function (label, n) {
        var on = n === index;
        label.classList.toggle("is-on", on);
        if (label.tagName === "BUTTON") label.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (meter) meter.style.setProperty("--meter", ((index + 1) / frames.length * 100) + "%");
      var map = root.querySelector("[data-rail-map]");
      if (map) map.style.setProperty("--rail", String(index));
      var caption = root.querySelector("[data-rail-caption]");
      var frame = frames[index];
      if (caption && frame && frame.getAttribute("data-note")) caption.textContent = frame.getAttribute("data-note");
    }

    function play() {
      window.clearTimeout(timer);
      if (reduce || paused) return;
      timer = window.setTimeout(function () {
        show(index + 1);
        play();
      }, hold);
    }

    function stop() {
      window.clearTimeout(timer);
      timer = 0;
    }

    if (pause) {
      pause.addEventListener("click", function () {
        paused = !paused;
        pause.textContent = paused ? "Play" : "Pause";
        pause.setAttribute("aria-pressed", paused ? "true" : "false");
        if (paused) stop();
        else play();
      });
      if (reduce) pause.hidden = true;
    }

    labels.forEach(function (label, n) {
      if (label.tagName !== "BUTTON") return;
      label.addEventListener("click", function () {
        show(n);
        paused = true;
        stop();
        if (pause) {
          pause.textContent = "Play";
          pause.setAttribute("aria-pressed", "true");
        }
      });
    });

    show(reduce ? frames.length - 1 : 0);
    stage(root, play, stop);
  }

  document.querySelectorAll("[data-reel]").forEach(reel);

  var mobileNav = window.matchMedia("(max-width: 800px)");
  var prefetched = {};
  document.addEventListener("pointerdown", function (event) {
    if (!mobileNav.matches) return;
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (!link) return;
    var href = link.getAttribute("href");
    if (!href || href.charAt(0) === "#" || /^(?:mailto|tel|javascript):/i.test(href) || /^https?:/i.test(href)) return;
    if (prefetched[href]) return;
    prefetched[href] = true;
    var hint = document.createElement("link");
    hint.rel = "prefetch";
    hint.href = href;
    document.head.appendChild(hint);
  });
})();
